import { useEffect, useState } from 'react';

import { STORAGE_KEYS } from '@constants/storage';
import { useLazyGetAllGroupsWithoutPaginationQuery } from '@features/group-management/queries/GroupQuery';
import useNotify from '@hooks/notify';
import { getLocalStorageItem } from '@utils/storage';
import { ApiError } from 'types/api';
import { DropdownOption } from 'types/dropdown';
import { Group } from 'types/groups';

const useGroupOptions = (branchId: string) => {
  const organizationId = getLocalStorageItem(STORAGE_KEYS.ORGANIZATION_ID);
  const { createErrorAlert } = useNotify();
  const [groupOptions, setGroupOptions] = useState<DropdownOption[]>([]);
  const [getAllGroups] = useLazyGetAllGroupsWithoutPaginationQuery();

  useEffect(() => {
    if (!branchId) {
      setGroupOptions([]);
      return;
    }

    const fetch = async () => {
      const res = await getAllGroups({
        params: { organizationId, branchId },
        queryString: '?status=active'
      });
      if (res.data) {
        const groups = Array.isArray(res.data) ? res.data : res.data.data || [];
        setGroupOptions(
          groups.map((g: Group) => ({
            id: g.id,
            label: g.name,
            value: g.id
          }))
        );
      } else if ('error' in res) {
        const error = res.error as ApiError;
        createErrorAlert(error.data?.message || 'Error fetching groups');
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId]);

  return groupOptions;
};

export default useGroupOptions;
